import React, { useRef } from 'react';
import { Maximize2 } from 'lucide-react';
import { Highlighter } from '../../lib/paper';
import { Tape } from '../paper';

/**
 * A small print of the original scan, taped down and knocked askew (mobile's
 * ScanPrint). Clicking reports the photo's rect so the Lightbox can grow out of
 * it; `lifted` hides the print while the Lightbox is up.
 */
export const ScanPrint: React.FC<{
  src: string;
  tone: Highlighter;
  onOpen: (rect: DOMRect | null) => void;
  width?: number;
  tilt?: number;
  lifted?: boolean;
}> = ({ src, tone, onOpen, width = 84, tilt = -3, lifted = false }) => {
  const img = useRef<HTMLImageElement>(null);
  return (
    <button
      type="button"
      onClick={() => onOpen(img.current?.getBoundingClientRect() ?? null)}
      aria-label="View original scan"
      className={`pb-squish relative block cursor-zoom-in rounded-[3px] border-none bg-surface-container-lowest p-[3px] pb-[9px] shadow-[0_4px_12px_rgba(28,27,25,0.14)] ${
        lifted ? 'opacity-0' : ''
      }`}
      style={{ '--tilt': `${tilt}deg` } as React.CSSProperties}
    >
      <img
        ref={img}
        src={src}
        alt=""
        draggable={false}
        className="block rounded-[1px] bg-surface-container object-cover"
        style={{ width, height: width * 1.25 }}
        onError={(e) => (e.currentTarget.style.visibility = 'hidden')}
      />
      {width >= 72 && (
        <span className="absolute bottom-[13px] right-[7px] flex h-5 w-5 items-center justify-center rounded-full bg-[rgba(0,0,0,0.45)] text-white">
          <Maximize2 size={11} />
        </span>
      )}
      <Tape tone={tone} width={40} height={13} rotate={6} className="left-5 top-[-6px]" />
    </button>
  );
};
